import React from "react"

export default function FontPreviewCell(props) {
  return (
    <div className="fontPreviewCell">
      <div className={`fontPreviewCellText ${ props.fontStyle }`}>The quick brown fox jumped over the lazy dog.</div>
      <div className="separator" />

      <div className="vStack">
        <div className="hStack">
          <div className="fontPreviewCellName">{props.fontName}</div>
          <div className="fontPreviewCellStyle">{props.fontStyle}</div>
        </div>

        <div className="fontPreviewCellDetails">{props.fontSize}, {props.fontWeight}</div>
      </div>
    </div>
  )
}